import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerChatRepository } from 'application/repositorySchemas/IBuyerChatRepository';
import { type IBuyerSendChatClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSendChatClient';
import { type IBuyerSetMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSetMeetingDateClient';
import { type IBuyerDeclineMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IBuyerDeclineMeetingDateClient';
import { type IBuyerConfirmMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IBuyerConfirmMeetingDateClient';

@injectable()
export class BuyerChatRepository implements IBuyerChatRepository {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerSendChatClient')
        public readonly sendChatClient: IBuyerSendChatClient,
        @inject('IBuyerSetMeetingDateClient')
        public readonly setMeetingDateClient: IBuyerSetMeetingDateClient,
        @inject('IBuyerDeclineMeetingDateClient')
        public readonly declineMeetingDateClient: IBuyerDeclineMeetingDateClient,
        @inject('IBuyerConfirmMeetingDateClient')
        public readonly confirmMeetingDateClient: IBuyerConfirmMeetingDateClient,
    ) {}

    public async send(chat_room_id: number, message: string) {
        const { data, message: resMessage } = await this.sendChatClient.post({
            token: this.buyerUserToken.get() || '',
            chat_room_id,
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }

        return data;
    }

    public async setMeetingDate(match_id: number, meeting_date: string) {
        const { data, message } = await this.setMeetingDateClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
            meeting_date,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declineMeetingDate(match_id: number) {
        const { data, message } = await this.declineMeetingDateClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async confirmMeetingDate(match_id: number) {
        const { data, message } = await this.confirmMeetingDateClient.post({
            token: this.buyerUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
